// extracted by mini-css-extract-plugin
export var root = "MarkdownSidenote-module--root--21525";